import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/JWTAuth_action";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import "../Header/index.css";
function Head(){
    const auth = useSelector((state)=>state.jwtAuthreducer);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const reset = ()=>{
        dispatch(logout());
    }
    const redirectToHome=()=>{
        navigate("/")
    }

    return(
    <header className="header inner-header">
        <div className="container d-flex align-items-center">
            <Link to="/" className="logo">
                <img src={process.env.PUBLIC_URL +  'img/bedater-logo.png' } alt="" title="" width="56" />
            </Link>
            <div className="ml-auto">
                <div className="dropdown my-account-dropdown">
                    <a className="dropdown-toggle" href="#" role="button" id="myAccountDD" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        <strong>Hi,</strong> {auth.user ? auth.user.username : ""}
                    </a>

                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="myAccountDD">
                        <Link className="dropdown-item" onClick={()=>reset()} >
                            <svg width="29" height="32" viewBox="0 0 29 32" fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M28.9999 17.5227C28.9993 20.1493 28.2833 22.7263 26.9287 24.9777C25.574 27.2292 23.6317 29.0702 21.3096 30.3038C18.9876 31.5373 16.3733 32.1169 13.7467 31.9804C11.1201 31.844 8.58011 30.9966 6.39876 29.5291C4.2174 28.0616 2.47682 26.0293 1.36339 23.6496C0.249955 21.27 -0.194387 18.6327 0.0779414 16.0202C0.35027 13.4077 1.32901 10.9184 2.90936 8.81878C4.48971 6.71919 6.61215 5.08841 9.0494 4.10106C9.18704 4.03856 9.33593 4.00455 9.48709 4.00106C9.63825 3.99758 9.78855 4.0247 9.92893 4.08078C10.0693 4.13687 10.1969 4.22076 10.3039 4.3274C10.411 4.43404 10.4953 4.56122 10.5518 4.70128C10.6083 4.84133 10.6358 4.99136 10.6327 5.14233C10.6296 5.29329 10.5959 5.44206 10.5336 5.57967C10.4714 5.71728 10.3819 5.84088 10.2705 5.94301C10.1591 6.04515 10.0282 6.12371 9.88565 6.17396C7.25114 7.24277 5.0706 9.19289 3.71732 11.6905C2.36404 14.188 1.9222 17.0777 2.46744 19.8648C3.01268 22.6519 4.51109 25.163 6.70613 26.9683C8.90118 28.7736 11.6563 29.7607 14.4999 29.7607C17.3435 29.7607 20.0987 28.7736 22.2938 26.9683C24.4888 25.163 25.9872 22.6519 26.5324 19.8648C27.0777 17.0777 26.6358 14.188 25.2826 11.6905C23.9293 9.19289 21.7487 7.24277 19.1142 6.17396C18.9717 6.12371 18.8407 6.04515 18.7294 5.94301C18.618 5.84088 18.5285 5.71728 18.4663 5.57967C18.404 5.44206 18.3703 5.29329 18.3672 5.14233C18.3641 4.99136 18.3916 4.84133 18.4481 4.70128C18.5046 4.56122 18.5889 4.43404 18.696 4.3274C18.803 4.22076 18.9306 4.13687 19.071 4.08078C19.2113 4.0247 19.3616 3.99758 19.5128 4.00106C19.664 4.00455 19.8128 4.03856 19.9505 4.10106C22.6318 5.1753 24.928 7.02919 26.5416 9.42236C28.1552 11.8155 29.0116 14.6376 28.9999 17.5227V17.5227ZM14.4999 16.1805C14.797 16.1805 15.0818 16.0627 15.2919 15.853C15.5019 15.6432 15.6199 15.3587 15.6199 15.0621V1.11847C15.6199 0.821834 15.5019 0.537346 15.2919 0.327592C15.0818 0.117838 14.797 0 14.4999 0C14.2029 0 13.918 0.117838 13.708 0.327592C13.498 0.537346 13.38 0.821834 13.38 1.11847V15.0621C13.38 15.209 13.4089 15.3544 13.4652 15.4901C13.5215 15.6258 13.604 15.7491 13.708 15.853C13.812 15.9568 13.9355 16.0392 14.0713 16.0954C14.2072 16.1516 14.3529 16.1805 14.4999 16.1805Z"
                                    fill="currentColor" />
                            </svg>

                            Logout
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </header>
    );
}

export default Head;


